<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý thiết bị kết nối về máy chủ</strong>
          <div class="card-header-actions">
            <CButton color="secondary" shape="pill"
                     @click="getAll">
              <CIcon name="cil-sync"/>
              Tải lại
            </CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="connections"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            hover
            sorter
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>

            <template #actions="{item, index}">
              <td>
                <CDropdown v-if="item.connect===1"
                  size="lg"
                  :caret="false"
                  placement="bottom-end">
                  <template #toggler>
                    <CButton variant="ghost">
                      <CIcon name="cil-list" size="lg"/>
                    </CButton>
                  </template>

                  <CDropdownItem v-if="item.activated===0 &&
                  item.connect===1" @click="activateDevice(item, index)">
                    <CIcon name="cil-lock-unlocked" class="mr-2"/>Activate</CDropdownItem>
                  <CDropdownItem v-if="item.connect===1" @click="disconnectDevice(item, index)">
                    <CIcon name="cil-link-broken" class="mr-2"/>Disconnect</CDropdownItem>
                </CDropdown>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Define the table fields
      fields: [
        { key: 'stt', label: 'No', _style:'width:3rem;' },
        { key: 'uuid', label: 'Seri' },
        { key: 'uid', label: 'MAC' },
        { key: 'description', label: 'Description' },
        { key: 'activated', label: 'Activated' },
        { key: 'connect', label: 'Connected' },
        { key: 'time', label: 'Update' },
        { key: 'actions', label: 'Actions' },
      ],
      // Example data
      connections: [],
    };
  },
  created() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.$request.get('/api/device/connections')
        .then(res=>{
          // console.log(res.data.connections)
          this.connections=res.data.connections
        })
    },
    disconnectDevice(item, index) {
      // console.log('disconnect device:', item);
      this.$request.post('/api/device/connection', {
        action: 'Disconnect',
        uuid: item.uuid,
      }).then(res => {
        if(res.data.status === 'success') {
          this.license = res.data.license;
          this.$swal.fire({
            icon: "success",
            title: "Disconnect device",
            html: "Disconnect device success ",
          });
          // this.$router.go(-1);
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Disconnect device",
            html: "Disconnect device error: " + res.data.status,
          });
        }
      })
    },
    activateDevice(item, index) {
      // console.log('activated device:', item);
      this.$request.post('/api/device/connection',{
        action: 'Activate',
        uuid: item.uuid,
      }).then(res => {
        if(res.data.status === 'success') {
          this.license = res.data.license;
          this.$swal.fire({
            icon: "success",
            title: "Activate device",
            html: "Activate device thành công"
          });
          // this.$router.go(-1);
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Activate device",
            html: "Activate device lỗi: " + res.data.status,
          });
        }
      })
    }
  },
};
</script>
